import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import {ToastContainer} from 'react-toastify'
import {fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions} from '../../../reusable'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-toastify/dist/ReactToastify.css'
import {Tr} from '../../../_metronic/i18n/Tr'

// Container to enable horizontal scrolling for the table
const TableContainer = styled.div`
  overflow-x: auto;
  width: 100%;
`

// Styled table with nowrap cells
const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;

  th,
  tr,
  td {
    border: 1px solid lightgray;
  }
  input {
    border: 1px solid lightgray !important;
  }
  th {
    border-bottom: 1px solid lightgray;
    font-size: 1.3rem;
    text-align: center;
    padding-right: 2rem;
  }
`

function LevelsPoint() {
  let t = Tr()
  const {menuIdEdit} = useMenuIdPermissions()

  // Input state
  const [data, setData] = useState([])

  // Fetch data from API
  const getLevelSystemList = async () => {
    try {
      const response = await fetchData('admin/getlevelspointlist', Object)
      if (response.status === 200) {
        setData(response.data)
      } else {
        toasterrormsg('Failed to fetch data')
      }
    } catch (error) {
      toasterrormsg('Failed to fetch data')
    }
  }

  useEffect(() => {
    getLevelSystemList()
    document.title = 'Insayr | Level System'
  }, [])

  // Update value in data array
  const handleChange = (index: number, key: string, value: string, title: string) => {
    // Check if the value is numeric (whole numbers)
    if (title === 'How to earn Levels' || title === 'Validity Period') {
      if (!/^\d*$/.test(value)) {
        return // Exit early if the value is not numeric
      }
    } else if (title !== 'Priority Assistance for Calls & Chats') {
      if (!/^\d*\.?\d*$/.test(value)) {
        return // Exit early if the value is not numeric
      } else if (!isNaN(parseFloat(value)) && parseFloat(value) > 100) {
        return
      }
    }

    // Keep empty string as is
    const sanitizedValue = value

    setData((prevData) => {
      const newData: any = [...prevData]
      newData[index][key] = sanitizedValue
      return newData
    })
  }

  // Validate submitted form
  const validate = (data: any[]) => {
    for (const item of data) {
      // Skip validation for "Priority Assistance for Calls & Chats"
      if (item.title === 'Priority Assistance for Calls & Chats') {
        continue
      }
      // Check for null or empty strings
      if (
        item.basic === null ||
        item.basic === '' ||
        item.silver === null ||
        item.silver === '' ||
        item.gold === null ||
        item.gold === '' ||
        item.platinum === null ||
        item.platinum === ''
      ) {
        toasterrormsg('Please Fill all Fields')
        return false
      }
      // Check for zero values
      if (
        /^(0+)$/.test(item.basic) ||
        /^(0+)$/.test(item.silver) ||
        /^(0+)$/.test(item.gold) ||
        /^(0+)$/.test(item.platinum)
      ) {
        toasterrormsg('Each field must have a value greater than zero.')
        return false
      }
      // Specific validation for "How to earn Levels"
      if (item.title === 'How to earn Levels') {
        if (item.silver && !isNaN(parseFloat(item.silver)) && parseFloat(item.silver) < 2) {
          toasterrormsg('User Must Have Atleast 1 Booking to Be in Silver Level')
          return false
        }
        if (item.gold && !isNaN(parseFloat(item.gold)) && parseFloat(item.gold) < 3) {
          toasterrormsg('User Must Have Atleast 3 Booking to Be in Gold Level')
          return false
        }
        if (item.platinum && !isNaN(parseFloat(item.platinum)) && parseFloat(item.platinum) < 8) {
          toasterrormsg('User Must Have Atleast 8 Booking to Be in Platinum Level')
          return false
        }
      }
    }
    return true
  }

  // On submit form data
  const onSubmit = async () => {
    let adminId = ''
    const adminDataString = sessionStorage.getItem('admin')

    if (adminDataString) {
      const adminData = JSON.parse(adminDataString)
      adminId = adminData.adminId
    }

    // Validate data
    if (!validate(data)) {
      return
    }

    try {
      // Prepare updated data array with updatedBy field
      const updatedData = data.map((item: any) => ({
        ...item,
        updatedBy: adminId,
        // // Convert empty strings to null for backend if needed
        // basic: item.basic === '' ? null : item.basic,
        // silver: item.silver === '' ? null : item.silver,
        // gold: item.gold === '' ? null : item.gold,
        // platinum: item.platinum === '' ? null : item.platinum,
      }))

      const param = {
        updatelevelsPointData: updatedData,
      }
      
      const res = await fetchData('admin/updatelevelspoint', param)
      if (res.status === 200) {
        toastsuccessmsg(res.message)
        getLevelSystemList()
      } else {
        toasterrormsg(res.message)
      }
    } catch (error) {
      toasterrormsg('Failed to submit form')
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container'>
        <div className='row mt-5'>
          <TableContainer>
            <StyledTable cellPadding={24} cellSpacing={9}>
              <thead>
                <tr>
                  <th></th>
                  <th>{t('Basic')}</th>
                  <th>{t('Silver')}</th>
                  <th>{t('Gold')}</th>
                  <th>{t('Platinum')}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((data: any, index: any) => {
                  return (
                    <tr key={data.levelSystemId}>
                      <td data-label='How to earn Levels'>
                        <div className='fw-bold' style={{width: '10rem'}}>
                          {data.title === 'Hotel Discounts' ? 'Discounts' : data.title}
                        </div>
                      </td>
                      {/* Basic Column */}
                      <td data-label='Basic'>
                        <div className='d-flex align-items-center justify-content-center fw-bold'>
                          {data.basic === null && data.title !== 'How to earn Levels' ? (
                            <span className='fw-bold'>-</span>
                          ) : isNaN(parseFloat(data.basic)) && data.basic !== '' ? (
                            <span className='fw-bold'>{data.basic}</span>
                          ) : (
                            <div className='d-flex align-items-center'>
                              <div
                                style={{
                                  width: '5rem',
                                  wordBreak: 'break-word',
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                  padding: '0.3rem',
                                }}
                              >
                                <span className='fw-bold'>
                                  {data.title === 'Hotel Discounts' ? 'Up To' : ''}
                                </span>
                              </div>
                              <input
                                type='text'
                                className='form-control form-control-solid w-60px h-40px'
                                value={data.basic || ''}
                                onChange={(e) =>
                                  handleChange(index, 'basic', e.target.value, data.title)
                                }
                              />
                              <div
                                style={{
                                  width: '8rem',
                                  wordBreak: 'break-word',
                                  display: 'flex',
                                  justifyContent: 'flex-start',
                                  padding: '0.3rem',
                                }}
                              >
                                <span className='fw-bold'>
                                  {data.title === 'How to earn Levels'
                                    ? 'Bookings'
                                    : data.title === 'Hotel Discounts'
                                    ? '% Off'
                                    : data.title === 'Validity Period'
                                    ? 'Months'
                                    : ''}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                      {/* Silver Column */}
                      <td data-label='Silver'>
                        <div className='d-flex align-items-center'>
                          <div
                            style={{
                              width: '5rem',
                              wordBreak: 'break-word',
                              display: 'flex',
                              justifyContent: 'flex-end',
                              padding: '0.3rem',
                            }}
                          >
                            <span className='fw-bold'>
                              {data.title === 'Earn Insayr Points'
                                ? 'Earn'
                                : data.title === 'Hotel Discounts'
                                ? 'Up to'
                                : ''}
                            </span>
                          </div>
                          {data.silver === null ? (
                            <span className='fw-bold'>-</span>
                          ) : isNaN(parseFloat(data.silver)) && data.silver !== '' ? (
                            <span className='fw-bold'>{data.silver}</span>
                          ) : (
                            <input
                              type='text'
                              className='form-control form-control-solid w-60px h-40px'
                              value={data.silver || ''}
                              onChange={(e) =>
                                handleChange(index, 'silver', e.target.value, data.title)
                              }
                            />
                          )}
                          <div
                            style={{
                              width: '8rem',
                              wordBreak: 'break-word',
                              display: 'flex',
                              justifyContent: 'flex-start',
                              padding: '0.3rem',
                            }}
                          >
                            <span className='fw-bold'>
                              {data.title === 'Earn Insayr Points'
                                ? '% More Insayr Points'
                                : data.title === 'Hotel Discounts'
                                ? '% Off '
                                : data.title === 'How to earn Levels'
                                ? 'Bookings'
                                : data.title === 'Validity Period'
                                ? 'Months'
                                : ''}
                            </span>
                          </div>
                        </div>
                      </td>
                      {/* Gold Column */}
                      <td data-label='Gold'>
                        <div className='d-flex align-items-center'>
                          <div
                            style={{
                              width: '5rem',
                              wordBreak: 'break-word',
                              display: 'flex',
                              justifyContent: 'flex-end',
                              padding: '0.3rem',
                            }}
                          >
                            <span className='fw-bold'>
                              {data.title === 'Earn Insayr Points'
                                ? 'Earn'
                                : data.title === 'Hotel Discounts'
                                ? 'Up to'
                                : ''}
                            </span>
                          </div>
                          {data.gold === null ? (
                            <span className='fw-bold'>-</span>
                          ) : isNaN(parseFloat(data.gold)) && data.gold !== '' ? (
                            <span className='fw-bold'>{data.gold}</span>
                          ) : (
                            <input
                              type='text'
                              className='form-control form-control-solid w-60px h-40px'
                              value={data.gold || ''}
                              onChange={(e) =>
                                handleChange(index, 'gold', e.target.value, data.title)
                              }
                            />
                          )}
                          <div
                            style={{
                              width: '8rem',
                              wordBreak: 'break-word',
                              display: 'flex',
                              justifyContent: 'flex-start',
                              padding: '0.3rem',
                            }}
                          >
                            <span className='fw-bold'>
                              {data.title === 'Earn Insayr Points'
                                ? '% More Insayr Points'
                                : data.title === 'Hotel Discounts'
                                ? '% Off '
                                : data.title === 'How to earn Levels'
                                ? 'Bookings'
                                : data.title === 'Validity Period'
                                ? 'Months'
                                : ''}
                            </span>
                          </div>
                        </div>
                      </td>
                      {/* Platinum Column */}
                      <td data-label='Platinum'>
                        <div className='d-flex align-items-center'>
                          <div
                            style={{
                              width: '5rem',
                              wordBreak: 'break-word',
                              display: 'flex',
                              justifyContent: 'flex-end',
                              padding: '0.3rem',
                            }}
                          >
                            <span className='fw-bold'>
                              {data.title === 'Earn Insayr Points'
                                ? 'Earn'
                                : data.title === 'Hotel Discounts'
                                ? 'Up to'
                                : ''}
                            </span>
                          </div>
                          {data.platinum === null ? (
                            <span className='fw-bold'>-</span>
                          ) : isNaN(parseFloat(data.platinum)) && data.platinum !== '' ? (
                            <span className='fw-bold'>{data.platinum}</span>
                          ) : (
                            <input
                              type='text'
                              className='form-control form-control-solid w-60px h-40px'
                              value={data.platinum || ''}
                              onChange={(e) =>
                                handleChange(index, 'platinum', e.target.value, data.title)
                              }
                            />
                          )}
                          <div
                            style={{
                              width: '8rem',
                              wordBreak: 'break-word',
                              display: 'flex',
                              justifyContent: 'flex-start',
                              padding: '0.3rem',
                            }}
                          >
                            <span className='fw-bold'>
                              {data.title === 'Earn Insayr Points'
                                ? '% More Insayr Points'
                                : data.title === 'Hotel Discounts'
                                ? '% Off '
                                : data.title === 'How to earn Levels'
                                ? 'Bookings'
                                : data.title === 'Validity Period'
                                ? 'Months'
                                : ''}
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </StyledTable>
          </TableContainer>
          <pre id='formDataDisplay' className='mt-4'></pre>
        </div>
      </div>
      <div className='d-flex align-items-center justify-content-center'>
        {menuIdEdit ? (
          <button className='btn btn-success mt-4' onClick={onSubmit}>
            {t('Submit')}
          </button>
        ) : (
          ''
        )}
      </div>
    </>
  )
}

export default LevelsPoint
